import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ChevronLeft, ChevronRight, Heart } from 'lucide-react';
import './Gallery.css';

// Import local images
import brunaLorhan4 from '../assets/BRUNA E LORHAN -4.jpg';
import brunaLorhan15 from '../assets/BRUNA E LORHAN -15.jpg';
import brunaLorhan23 from '../assets/BRUNA E LORHAN -23.jpg';
import brunaLorhan57 from '../assets/BRUNA E LORHAN -57.jpg';
import brunaLorhan36 from '../assets/BRUNA E LORHAN -36.jpg';
import brunaLorhan131 from '../assets/BRUNA E LORHAN -131.jpg';
import brunaLorhan156 from '../assets/BRUNA E LORHAN -156.jpg';
import brunaLorhan159 from '../assets/BRUNA E LORHAN -159.jpg';
import brunaLorhan167 from '../assets/BRUNA E LORHAN -167.jpg';
import brunaLorhan169 from '../assets/BRUNA E LORHAN -169.jpg';
import brunaLorhan177 from '../assets/BRUNA E LORHAN -177.jpg';
import brunaLorhan180 from '../assets/BRUNA E LORHAN -180.jpg';
import brunaLorhan189 from '../assets/BRUNA E LORHAN -189.jpg';
import brunaLorhan218 from '../assets/BRUNA E LORHAN -218.jpg';
import brunaLorhan236 from '../assets/BRUNA E LORHAN -236.jpg';
import brunaLorhan237 from '../assets/BRUNA E LORHAN -237.jpg';
import brunaLorhan279 from '../assets/BRUNA E LORHAN -279.jpg';
import brunaLorhan281 from '../assets/BRUNA E LORHAN -281.jpg';
import brunaLorhan358 from '../assets/BRUNA E LORHAN -358.jpg';
import brunaLorhan362 from '../assets/BRUNA E LORHAN -362.jpg';
import brunaLorhan350 from '../assets/BRUNA E LORHAN -350.jpg';

const Gallery: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  // Gallery images using local assets
  const galleryImages = [
    {
      id: 1,
      src: brunaLorhan4,
      alt: 'Bruna e Lorhan - Foto 4',
      category: 'engagement'
    },
    {
      id: 2,
      src: brunaLorhan15,
      alt: 'Bruna e Lorhan - Foto 15',
      category: 'engagement'
    },
    {
      id: 3,
      src: brunaLorhan23,
      alt: 'Bruna e Lorhan - Foto 23',
      category: 'engagement'
    },
    {
      id: 4,
      src: brunaLorhan57,
      alt: 'Bruna e Lorhan - Foto 57',
      category: 'engagement'
    },
    {
      id: 5,
      src: brunaLorhan36,
      alt: 'Bruna e Lorhan - Foto 36',
      category: 'engagement'
    },
    {
      id: 6,
      src: brunaLorhan131,
      alt: 'Bruna e Lorhan - Foto 131',
      category: 'engagement'
    },
    {
      id: 7,
      src: brunaLorhan156,
      alt: 'Bruna e Lorhan - Foto 156',
      category: 'engagement'
    },
    {
      id: 8,
      src: brunaLorhan159,
      alt: 'Bruna e Lorhan - Foto 159',
      category: 'engagement'
    },
    {
      id: 9,
      src: brunaLorhan167,
      alt: 'Bruna e Lorhan - Foto 167',
      category: 'engagement'
    },
    {
      id: 10,
      src: brunaLorhan169,
      alt: 'Bruna e Lorhan - Foto 169',
      category: 'engagement'
    },
    {
      id: 11,
      src: brunaLorhan177,
      alt: 'Bruna e Lorhan - Foto 177',
      category: 'engagement'
    },
    {
      id: 12,
      src: brunaLorhan180,
      alt: 'Bruna e Lorhan - Foto 180',
      category: 'engagement'
    },
    {
      id: 13,
      src: brunaLorhan189,
      alt: 'Bruna e Lorhan - Foto 189',
      category: 'engagement'
    },
    {
      id: 14,
      src: brunaLorhan218,
      alt: 'Bruna e Lorhan - Foto 218',
      category: 'engagement'
    },
    {
      id: 15,
      src: brunaLorhan236,
      alt: 'Bruna e Lorhan - Foto 236',
      category: 'engagement'
    },
    {
      id: 16,
      src: brunaLorhan237,
      alt: 'Bruna e Lorhan - Foto 237',
      category: 'engagement'
    },
    {
      id: 17,
      src: brunaLorhan279,
      alt: 'Bruna e Lorhan - Foto 279',
      category: 'engagement'
    },
    {
      id: 18,
      src: brunaLorhan281,
      alt: 'Bruna e Lorhan - Foto 281',
      category: 'engagement'
    },
    {
      id: 19,
      src: brunaLorhan358,
      alt: 'Bruna e Lorhan - Foto 358',
      category: 'engagement'
    },
    {
      id: 20,
      src: brunaLorhan362,
      alt: 'Bruna e Lorhan - Foto 362',
      category: 'engagement'
    },
    {
      id: 21,
      src: brunaLorhan350,
      alt: 'Bruna e Lorhan - Foto 350',
      category: 'engagement'
    }
  ];

  const categories = [
    { id: 'all', name: 'Todas as Fotos' },
    { id: 'engagement', name: 'Noivado' },
    { id: 'wedding', name: 'Dia do Casamento' },
    { id: 'reception', name: 'Recepção' }
  ];

  const [activeCategory, setActiveCategory] = useState('all');

  const filteredImages = activeCategory === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === activeCategory);

  const openLightbox = (index: number) => {
    setSelectedImage(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const nextImage = () => {
    if (selectedImage !== null) {
      setSelectedImage((selectedImage + 1) % filteredImages.length);
    }
  };

  const prevImage = () => {
    if (selectedImage !== null) {
      setSelectedImage(selectedImage === 0 ? filteredImages.length - 1 : selectedImage - 1);
    }
  };

  return (
    <div className="gallery">
      <div className="gallery-hero">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="gallery-hero-content"
          >
            <h1>Galeria de Fotos</h1>
            <p>Capturando nossos momentos especiais juntos</p>
          </motion.div>
        </div>
      </div>

      <div className="gallery-content">
        <div className="container">
          {/* Category Filter */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="category-filter"
          >
            {categories.map((category) => (
              <button
                key={category.id}
                className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                onClick={() => setActiveCategory(category.id)}
              >
                {category.name}
              </button>
            ))}
          </motion.div>

          {/* Gallery Grid */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="gallery-grid"
          >
            {filteredImages.map((image, index) => (
              <motion.div
                key={image.id}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="gallery-item"
                onClick={() => openLightbox(index)}
              >
                <img src={image.src} alt={image.alt} />
                <div className="gallery-overlay">
                  <Heart className="overlay-icon" />
                </div>
              </motion.div>
            ))}
          </motion.div>

          {filteredImages.length === 0 && (
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="no-photos"
            >
              <Heart className="no-photos-icon" />
              <p>Nenhuma foto nesta categoria ainda. Volte em breve!</p>
            </motion.div>
          )}
        </div>
      </div>

      {/* Lightbox */}
      <AnimatePresence>
        {selectedImage !== null && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="lightbox"
            onClick={closeLightbox}
          >
            <button className="lightbox-close" onClick={closeLightbox}>
              <X />
            </button>
            
            <button 
              className="lightbox-nav lightbox-prev" 
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
            >
              <ChevronLeft />
            </button>
            
            <button 
              className="lightbox-nav lightbox-next" 
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
            >
              <ChevronRight />
            </button>

            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              className="lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <img 
                src={filteredImages[selectedImage].src} 
                alt={filteredImages[selectedImage].alt} 
              />
              <div className="lightbox-caption">
                <p>{filteredImages[selectedImage].alt}</p>
                <span>{selectedImage + 1} de {filteredImages.length}</span>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Gallery;
